/**
 * Lector de la paleta categórica de dato (--data-*, spec-03).
 *
 * Recharts y Leaflet reciben color como string en JS, no como className, así
 * que acá es donde el color sale del CSS hacia JS — una sola vez. No es un
 * contexto de React: 12 constantes no justifican un proveedor
 * (technical-design-criteria.md §4.2).
 */

// Grises: nunca se ve un gráfico o un marcador sin color, incluso si el CSS
// todavía no aplicó (escenario 7 de spec-03).
const CATEGORICAL_FALLBACK = ['#8d93a1', '#61656f', '#6f7482', '#4b5563', '#374151', '#282c35'];
const SCALE_FALLBACK = ['#8d93a1', '#787e8d', '#61656f', '#4b5563', '#374151'];

let categoricalCache = null;
let scaleCache = null;

function readChannels(style, name) {
  const ch = style.getPropertyValue(name).trim();
  return ch ? `rgb(${ch})` : null;
}

/** Paleta categórica (6 tonos, R1 = C). Un color por categoría. */
export function getDataPalette() {
  if (categoricalCache) return categoricalCache;

  const style = getComputedStyle(document.documentElement);
  const palette = [1, 2, 3, 4, 5, 6].map((n) => readChannels(style, `--data-${n}-rgb`));

  if (palette.some((c) => !c)) return CATEGORICAL_FALLBACK; // CSS aún no aplicado

  categoricalCache = palette;
  return categoricalCache;
}

/** Escala secuencial de magnitud (5 pasos), para el heatmap. No es categórica. */
export function getDataScale() {
  if (scaleCache) return scaleCache;

  const style = getComputedStyle(document.documentElement);
  const scale = [1, 2, 3, 4, 5].map((n) => readChannels(style, `--data-scale-${n}-rgb`));

  if (scale.some((c) => !c)) return SCALE_FALLBACK;

  scaleCache = scale;
  return scaleCache;
}

/**
 * Color por índice estable (p. ej. por id de equipo o técnico), reutilizando
 * la paleta cuando hay más series que colores (escenario 6 de spec-03): quien
 * llama debe sumar un segundo recurso de diferenciación (forma, borde, etiqueta).
 */
export function getDataColor(index) {
  const palette = getDataPalette();
  return palette[index % palette.length];
}
